import { getProjects as getProjectsRest, getProject as getProjectRest } from '../rest/index.tsx';
import { transformProject, transformProjects } from './transformers.tsx';
import type { RequestProject, RequestProjects } from './types.tsx';

export const requestProjects: RequestProjects = (
	filter,
	{ detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType },
) =>
	getProjectsRest(
		filter,
		detailed,
		requireBrowsePermission,
		requireEditPermission,
		maxResults,
		projectType,
	).then(transformProjects);

export const requestProject: RequestProject = (projectId) =>
	getProjectRest(projectId).then(transformProject);
